module.exports = __webpack_public_path__ + "media/images/icons/search-9f3cf28911c1d805814e17d6ea2f4d4a.svg";